import { render, staticRenderFns } from "./FamilyDogDisplayAndEdit.vue?vue&type=template&id=972b357e&scoped=true&"
import script from "./FamilyDogDisplayAndEdit.vue?vue&type=script&lang=js&"
export * from "./FamilyDogDisplayAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./FamilyDogDisplayAndEdit.vue?vue&type=style&index=0&id=972b357e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972b357e",
  null
  
)

export default component.exports